import type { Query, QueryKey } from "@tanstack/react-query";

import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";

import { QUERY_PERSIST_KEY } from "./query.constant";

export const getSafeQueryKey = (queryKey: QueryKey) => {
  if (!queryKey) return [];

  if (!Array.isArray(queryKey)) return [queryKey];

  return queryKey;
};

/**
 * Creates a Local Storage persister
 * @see https://tanstack.com/query/latest/docs/framework/react/plugins/persistQueryClient
 */
export const createLocalStoragePersister = () => {
  return createAsyncStoragePersister({
    storage: window.localStorage,
  });
};

/**
 * Persists only specific queries
 * @see https://github.com/TanStack/query/discussions/3568
 */
export const shouldDehydrateQuery = (query: Query) => {
  const queryKey = getSafeQueryKey(query.queryKey);
  const shouldPersist = queryKey.includes(QUERY_PERSIST_KEY);
  const isSuccess = query.state.status === "success";

  return shouldPersist && isSuccess;
};
